import React from 'react';
import ReactDOM from 'react-dom';
import { KatSpinner } from '@amzn/katal-react';

import { App } from './components/App';
// eslint-disable-next-line import/no-named-as-default
import AppInitWrapper from './components/AppInitWrapper';
import './logger';

import '@amzn/katal-components/styles.css';
import './index.scss';
import '../css/flo.scss';
import '../css/trim.scss';

// The Suspense component causes React to display the fallback KatSpinner until
// the i18n translation strings have been loaded.

ReactDOM.render(
  <React.StrictMode>
    <AppInitWrapper>
      <React.Suspense fallback={<KatSpinner size="large" />}>
        <App />
      </React.Suspense>
    </AppInitWrapper>
  </React.StrictMode>,
  document.getElementById('root')
);
